import { interestStatus, sumInterestStatus, } from '@debbie/common/dist/economy/case-vouchers/interest-status.js';
import { isEngineV2Case } from '@debbie/common/dist/economy/helpers/policy.js';
import { isPayment } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { VoucherTypeSetting } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherInterestSettings } from '@debbie/common/dist/economy/vouchers/setup.js';
import { Site } from '@debbie/common/dist/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useCaseConditions } from '@debbie/cortex/dist/case-conditions/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useLimitationDocuments } from '@debbie/cortex/dist/documents/index.js';
import { useEconomyPolicy } from '@debbie/cortex/dist/economy-policy/index.js';
import { useFixedDistributionsByCaseId } from '@debbie/cortex/dist/fixed-distributions/index.js';
import { useInterestCalulation } from '@debbie/cortex/dist/heavy-calculations/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import { Money, Table, Tag } from '../../index.js';
import Billings from '../Billings.js';
import CaseVoucherInfoActions from './CaseVoucherInfoActions.js';
import CaseVoucherInfoDistributions from './CaseVoucherInfoDistributions.js';
import CaseVoucherInfoMeta from './CaseVoucherInfoMeta.js';
const CaseVoucherInfo = (props) => {
    const { caseVoucher, caseVouchers, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const documentsLoader = useLimitationDocuments(singleCase?.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const site = useSelector((s) => s.site);
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const until = moment().format();
    const fixedDistributionsLoader = useFixedDistributionsByCaseId(singleCase?.caseId);
    const fixedDistributions = h.hasData(fixedDistributionsLoader)
        ? fixedDistributionsLoader.data
        : null;
    const conditionsLoader = useCaseConditions(singleCase?.caseId);
    const conditions = h.hasData(conditionsLoader) ? conditionsLoader.data : null;
    const interestLoader = useInterestCalulation(JSON.parse(JSON.stringify(_caseVouchers)), documents, useEconomyPolicy(singleCase), fixedDistributions, conditions, until, { appendHist: true });
    const caseVouchersWithHistory = h.hasData(interestLoader)
        ? interestLoader.data
        : null;
    // Only engine v2 tracks what of the interest is paid or acknowledged
    const showInterestStatus = singleCase != null && isEngineV2Case(singleCase);
    const voucherWithInterestHistory = caseVouchersWithHistory &&
        caseVouchersWithHistory.find((v) => v.caseVoucherId === caseVoucher.caseVoucherId);
    const isCompoundInterest = voucherWithInterestHistory?.setting === VoucherTypeSetting.CompoundInterest;
    const hasInterestStatus = showInterestStatus &&
        (voucherWithInterestHistory?.interestHistory ?? []).some((row) => interestStatus(lang, row).length > 0);
    return (React.createElement(React.Fragment, null,
        caseVoucher.associationId && (React.createElement(React.Fragment, null,
            React.createElement(AssociationIcon, { style: { margin: '0.2em 0 -0.2em' } }),
            ' ',
            lang.associateCases.caseVoucherIsAssociated)),
        React.createElement(CaseVoucherInfoMeta, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, singleCase: singleCase }),
        React.createElement(Tags, null, caseVoucher.tags?.map((tag, key) => {
            return (React.createElement(Tag, { key: key }, lang.caseVoucherTags[tag.tag] || tag.tag));
        })),
        voucherWithInterestHistory &&
            voucherWithInterestHistory.setting &&
            CaseVoucherInterestSettings.includes(voucherWithInterestHistory.setting) &&
            voucherWithInterestHistory.interestHistory && (React.createElement(InterestHistory, null,
            React.createElement("h3", null, lang.economy.voucherInfoInterestHis),
            React.createElement(Table, { zebra: true, sumRow: showInterestStatus, overflowX: "auto", style: { width: 'auto' } },
                React.createElement("tr", null,
                    React.createElement("th", null, lang.economy.voucherInfoIfrom),
                    React.createElement("th", null, lang.economy.voucherInfoITo),
                    React.createElement("th", null, lang.economy.voucherInfoIInterval),
                    React.createElement("th", { className: "tar" }, lang.economy.voucherInfoIRVA),
                    isCompoundInterest && (React.createElement("th", { className: "tar" }, lang.economy.voucherInfoICompoundedAmount)),
                    React.createElement("th", { className: "tar" }, lang.economy.amount),
                    hasInterestStatus && (React.createElement("th", null, lang.economy.voucherInfoIReason))),
                voucherWithInterestHistory.interestHistory &&
                    [...voucherWithInterestHistory.interestHistory]
                        // Reapplied rows carry nominal dates but are appended at
                        // the default, so sort for display. Dates are calendar
                        // days at UTC midnight.
                        .sort((a, b) => a.from - b.from || a.to - b.to)
                        .map((item, key) => (React.createElement("tr", { key: key },
                        React.createElement("td", null, moment.utc(item.from).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("td", null, moment.utc(item.to).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement(IntervalCell, null,
                            moment
                                .utc(item.to)
                                .diff(moment.utc(item.from), 'days'),
                            ' ',
                            lang.economy.voucherInfoIDays,
                            item.reapplied && (React.createElement(ReappliedBadge, null, lang.economy.voucherInfoIReapplied))),
                        React.createElement("td", { className: "tar" },
                            React.createElement("small", null,
                                "(",
                                `${parseFloat((item.interest * 100).toFixed(3))}`.replace('.', ','),
                                ' ',
                                "%)"),
                            ' ',
                            React.createElement(Money, { amount: item.referenceVoucherBalance })),
                        isCompoundInterest && (React.createElement("td", { className: "tar" },
                            React.createElement(Money, { amount: item.capitalizedInterestBalance || 0 }))),
                        React.createElement("td", { className: "tar" },
                            React.createElement(Money, { amount: item.amount })),
                        hasInterestStatus && React.createElement(InterestStatusCell, { row: item })))),
                showInterestStatus && (React.createElement(InterestTotals, { isCompoundInterest: isCompoundInterest, hasInterestStatus: hasInterestStatus, history: voucherWithInterestHistory.interestHistory }))))),
        voucherWithInterestHistory && _caseVouchers && (React.createElement(CaseVoucherInfoDistributions, { voucher: voucherWithInterestHistory, caseVouchers: _caseVouchers, fixedDistributions: fixedDistributions, singleCase: singleCase })),
        isPayment(caseVoucher) && tenant?.type === TenantType.Agency && (React.createElement(BillingsSection, null,
            React.createElement("h3", null, lang.billing.appendix),
            React.createElement(Billings, { depositCaseVoucherId: caseVoucher.caseVoucherId }))),
        React.createElement("br", null),
        site === Site.Caseworker && React.createElement(CaseVoucherInfoActions, { ...props })));
};
export default CaseVoucherInfo;
const InterestStatusCell = ({ row }) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("td", null, interestStatus(lang, row).map((part) => (React.createElement(InterestStatusPart, { key: part.label },
        part.amount !== null && (React.createElement(React.Fragment, null,
            React.createElement(Money, { amount: part.amount }),
            ' ')),
        part.label)))));
};
// Fra, Til, Interval and Ref. posteringsbeløb
const leadingColumns = 4;
// Its cells line up with the history rows' above
const InterestTotals = ({ isCompoundInterest, hasInterestStatus, history, }) => {
    const lang = useSelector((s) => s.lang);
    const total = history.reduce(sumInterestStatus, {
        amount: 0,
        paid: 0,
        acknowledged: 0,
    });
    return (React.createElement("tr", null,
        React.createElement("td", { colSpan: leadingColumns }, lang.economy.sum),
        isCompoundInterest && React.createElement("td", null),
        React.createElement("td", { className: "tar" },
            React.createElement(Money, { amount: total.amount })),
        hasInterestStatus && React.createElement(InterestStatusCell, { row: total })));
};
const Tags = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 14px;
  padding: 6px 0;
`;
const InterestHistory = styled.div `
  margin-bottom: 20px;

  td {
    vertical-align: top;
  }
`;
// Keeps "18 dage" on one line; a narrow table wraps the reference balance
const IntervalCell = styled.td `
  white-space: nowrap;
`;
const InterestStatusPart = styled.div `
  white-space: nowrap;
`;
const ReappliedBadge = styled.small `
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 4px;
  background: #fff3e0;
  color: #b25e00;
`;
const BillingsSection = styled.div `
  margin-top: 10px;
`;
//# sourceMappingURL=CaseVoucherInfo.js.map